var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-sight",
    transform: "translate(-102.4 -102.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20891",
    "data-name": "Path 20891",
    d: "M125.03,376.775a17.34,17.34,0,0,0-22.63,9.35,17.336,17.336,0,0,0,32,0A17.251,17.251,0,0,0,125.03,376.775Zm-1.021,16.231a14.663,14.663,0,0,1-18.676-6.881,14.67,14.67,0,0,1,26.133,0A14.523,14.523,0,0,1,124.009,393.006Z",
    transform: "translate(0 -262.392)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20892",
    "data-name": "Path 20892",
    d: "M184.122,118.4a5.333,5.333,0,1,0,5.333,5.333A5.334,5.334,0,0,0,184.122,118.4Zm0,8a2.667,2.667,0,1,1,2.667-2.666,2.666,2.666,0,0,1-2.667,2.666Zm-1.333-24h2.666v8h-2.666Zm14.66,4.624-3.987,5.694-2.185-1.53,3.987-5.694Zm-24.471-1.531,3.988,5.7-2.185,1.53-3.988-5.7Z",
    transform: "translate(-65.721)",
    fill: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.f4142279f6733ecf2d3b270d8fedde94.svg";
export { ForwardRef as ReactComponent };